export const odluka_predstavnik_prekrsaj= {
    templateId: 231.1,
    category: 7,
    templateTitle: 'Odluka o imenovanju ovlaštenog predstavnika pravne osobe u prekršajnom postupku',
    templateDescription: `<p>Prema prvom pozivu suda, okrivljena pravna osoba dužna je imenovati predstavnika u prekršajnom postupku te dostaviti dokaz da je imenovana osoba ovlaštena predstavljati pravnu osobu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
   
    <p>Sud će u prvom pozivu okrivljenu pravnu osobu pozvati da pisanim putem imenuje svog predstavnika i dostavi dokaze da je ta osoba sukladno ovome Zakonu ovlaštena predstavljati tu pravnu osobu.</p>
    <p>Pravna osoba odluku o imenovanju predstavnika dostavlja prije započinjanja postupka ili tu odluku prilikom poduzimanja prve radnje u postupku sudu predaje sam predstavnik pravne osobe.    </p>
    <p>Za okrivljenu pravnu osobu i s njom izjednačenog subjekta može se predstavnikom u prekršajnom postupku imenovati:</p>
    
    <li>osoba upisana u sudskom ili drugom registru kao osoba ovlaštena za zastupanje,</li>
    <li>zaposlenik ili član pravne osobe kojeg direktor ili druga čelna osoba okrivljene pravne osobe i s njom izjednačenog subjekta imenuje kao predstavnika pravne osobe.</li>
    <br>
    <p>Ako okrivljena pravna osoba i s njom izjednačen subjekt ne postupi kako je gore navedeno ili sud ocijeni da postoji sukob interesa između pravne osobe i odgovorne osobe, sud će rješenjem odrediti njezina predstavnika u prekršajnom postupku.</p>
    <p>Ako takve osobe nema, sud će odredit rješenjem pravnoj osobi branitelja po službenoj dužnosti koji će imati sve ovlasti predstavnika pravne osobe. Protiv tako postavljenog branitelja ne mogu se primjenjivati prisilne mjere koje se prema zakonu mogu primijeniti prema predstavniku okrivljenika – pravne osobe.</p>
    <p>Neće se određivati predstavnik pravne osobe ako su ispunjeni uvjeti za vođenje postupka bez nazočnosti okrivljene pravne osobe.</p>
    

  
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Prekršajni zakon.</p>
    `,
  
  sides: [
    {
      prefix: 'Na temelju odredbi Prekršajnog zakona,',
      signature: 'Za Društvo:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Društvu),",
    }
  ],

  headline: 'donosi sljedeću',
  title: 'ODLUKU O IMENOVANJU OVLAŠTENOG PREDSTAVNIKA DRUŠTVA U PREKRŠAJNOM POSTUPKU',

  noArticleNumbers: true,

  articles: [

    {
      title: '',
      mandatory: false,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Društvo je okrivljenik u prekršajnom postupku pred ___________________________, koji se vodi pod Posl. br. ___________. .'
        }]
    },
    {
        title: '',
        mandatory: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                { type: 'text', content: 'Za ovlaštenog predstavnika Društva u gore navedenom postupku imenuje se' },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'text', content: 'zaposlen na radnom mjestu' },
                { type: 'input', value: '', required: true, placeholder: "Naziv radnog mjesta"},
                { type: 'text', content: ', (u daljnjem tekstu: Radnik).'},
       
            ]
          }]
      },
    {
        title: '',
        mandatory: true,
        examplecontent: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: `Ova Odluka primjenjuje se od trenutka donošenja i primjenjuje se do opoziva.`,
          }]
      },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signature
      statements: [],
    },
  ],
};




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/231.1._odluka_predstavnik_prekrsaj.ts